import React from 'react';
import PropTypes from 'prop-types';

import EditableTextField from '../forms/editableTextField.jsx';
import ToolTip, {tooltipPositions} from 'components/ToolTip';

class LayoutInput extends React.PureComponent {
  static propTypes = {
    condition: PropTypes.bool,
    dataChanged: PropTypes.func,
    dataKey: PropTypes.string,
    dirtied: PropTypes.number,
    disabled: PropTypes.any,
    editMode: PropTypes.bool,
    label: PropTypes.string,
    placeholder: PropTypes.string,
    type: PropTypes.string,
    unit: PropTypes.string,
    validate: PropTypes.func,
    validateMessage: PropTypes.string,
    value: PropTypes.any,
    group: PropTypes.object,
    required: PropTypes.bool,
    noLabel: PropTypes.bool,
    grayedOut: PropTypes.bool,
    errorMessage: PropTypes.string,
    toolTip: PropTypes.string,
  };

  static defaultProps = {
    condition: true,
    editMode: true,
    disabled: false,
    label: '',
    dataKey: '',
    unit: null,
  };

  state = {
    value: this.props.value,
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.value !== this.props.value || nextProps.dirtied !== this.props.dirtied) {
      this.setState({
        value: nextProps.value,
      });
    }
  }

  getValue = () => {
    return this.state.value;
  };

  onChange = ({key, value}) => {
    if (this.props.dataChanged) {
      this.props.dataChanged({key, value});
    }

    this.setState({value});
  };

  focus = () => {
    this.refs.inner.focus();
  };

  highlight = () => {
    this.refs.inner.highlight();
  };

  render() {
    let disabled = this.props.disabled;

    if (disabled instanceof Array) {
      disabled = disabled.indexOf(this.props.dataKey) !== -1;
    }
    if (this.props.condition) {
      return <div className='form-group' style={this.props.style}>
        {!this.props.noLabel ?
          <label>
            {this.props.label}
            {this.props.required && this.props.editMode ?
              <span className='error' style={{marginLeft: 2}}>*</span> :
              null}
            {this.props.toolTip ? <ToolTip title={this.props.toolTip} position={tooltipPositions.topRight} iconOnly /> : null}
          </label> :
          null}
        <EditableTextField ref='inner'
          {...this.props}
          value={this.state.value}
          onChange={this.onChange}
          disabled={disabled} />
      </div>;
    }

    return null;
  }
}

export default LayoutInput;
